import { useState } from "react";
import { Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../assets/styles/customTable.scss";
import useColumnResize from "../../../hooks/useColumnResize";

const AddressesExPnTable = ({ data, onSortChange, mode = "EX" }) => {
  const [sortConfig, setSortConfig] = useState({ key: "Terminal", direction: "asc" });
  const { getResizeProps } = useColumnResize();
  const isDr = mode === "DR";
  const terminalLabel = isDr ? "Terminal DR" : "Terminal EX";
  const pnLabel = isDr ? "DR_PN" : "EX_PN";

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig);
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  const items = Array.isArray(data) ? data : [];

  return (
    <div>
      <Table
        responsive
        striped
        bordered
        hover
        size="sm"
        className="custom-table"
      >
        <thead>
          <tr>
            <th onClick={() => requestSort("Terminal")} {...getResizeProps()}>{terminalLabel} {getSortArrow("Terminal")}</th>
            <th onClick={() => requestSort("Pn")} {...getResizeProps()}>{pnLabel} {getSortArrow("Pn")}</th>
            <th onClick={() => requestSort("Count")} {...getResizeProps()}>Suma {getSortArrow("Count")}</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <tr key={`${item.terminal}-${item.pn}-${index}`}>
                <td>{item.terminal}</td>
                <td>{item.pn}</td>
                <td>{item.count}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default AddressesExPnTable;

